import PropTypes from 'prop-types'
import MinimalHeader from '../shared/MinimalHeader'

/**
 * NarrativeDashboardLayout Component
 *
 * Minimal layout for Narrative Dashboard
 * Story-focused interface with location context
 * Location selector is built into narrative components
 */
function NarrativeDashboardLayout({ children }) {
  return (
    <div className="min-h-screen bg-gray-50">
      <MinimalHeader title="Narrative Dashboard" icon="📖" />
      <main>{children}</main>
    </div>
  )
}

NarrativeDashboardLayout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default NarrativeDashboardLayout
